export default "__VITE_ASSET__B_HVK1Ec__"